import React, { FC } from 'react';
import Button from './Button';
import { IconType } from './Icon';
import Popover from './Popover';
import Select from './Select';
import { SelectGroupProps } from './SelectGroup';
import { Placement } from '@floating-ui/react';

interface PopoverSelectProps {
  label: string;
  iconLeft?: IconType;
  iconRight?: IconType;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  groups: SelectGroupProps[];
  filterable?: boolean;
  trigger?: React.ReactNode;
  placement?: Placement;
  offsetSize?: number;
}

const PopoverSelect: FC<PopoverSelectProps> = ({
  groups,
  label,
  isOpen,
  setIsOpen,
  iconLeft,
  iconRight,
  filterable,
  trigger,
  placement,
  offsetSize,
}) => {
  return (
    <>
      <Popover
        data-testid="select-popover"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        trigger={trigger || <Button type="secondary" label={label} iconLeft={iconLeft} iconRight={iconRight} />}
        body={<Select groups={groups} filterable={filterable} />}
        placement={placement}
        offsetSize={offsetSize}
      />
    </>
  );
};

export default PopoverSelect;
